import { connect } from 'react-redux'
import BlogFilterModal from './BlogFilterModal'
import { replace } from 'react-router-redux'

const stateToProps = (other, { category, author, searchTerm }) => ({
  initialValues: {
    category,
    author,
    searchTerm,
  },
})

const dispatchToProps = {
  replace,
}

export default connect(stateToProps, dispatchToProps)(BlogFilterModal)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogFilterModal/BlogFilterModal.container.js